import styled from "styled-components";
import { ArenaHeaderButtonLabelSICisBox } from "./arena-header-button-label.si.cis.box";

export const ArenaHeaderButtonLabelMrGreenCisBox = styled(ArenaHeaderButtonLabelSICisBox)`
    color: ${props => props.theme.colors.brandPrimaryContrast};
`;